import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitTypeServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitTypeServices";

const UpdateStudyKitTypeMetadata = ({
  kitTypeData,
  getEIWRSKitTypeMetadataData,
  Show,
  Hide,
  Title,
  setKitTypeId,
}) => {
  const { studyId } = useParams()
  const [kitType, setKitType] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSKitTypeMetadataData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Kit Type!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitTypeData?._id;
        userData.studyId = studyId;
        userData.type = kitType;
        let data = await eiwrsKitTypeServices.updateEIWRSKitTypeMetadataData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSKitTypeMetadataData();
          Hide();
          setKitTypeId("");
          setKitType("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    if(kitTypeData){
      setKitType(kitTypeData?.type);
    }
  }, [kitTypeData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Kit Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setKitType(e.target.value)}
              value={kitType}
              className="br3"
              placeholder="Enter Kit Type"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!kitType || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSKitTypeMetadataData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Kit Type"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyKitTypeMetadata;
